<template>
  <generic-modal
    size
    :title="$t('course configuration')"
    icon="user graduate"
    image="/images/icons/graduate.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="ui top attached tabular menu">
          <a class="active item" data-tab="branch_general">
            <i class="info icon"></i>
            {{ $t("general info") }}
          </a>
        </div>
        <div class="ui bottom attached active tab segment" data-tab="branch_general">
          <div class="field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="setup.name" />
          </div>
          <!-- <pre>{{ setup }}</pre> -->
        </div>
        <div class="ui message error"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";

export default {
  name: "careerModalIndex",
  components: {
    "generic-modal": GenericModal
  },
  props: {
    career_uuid: String
  },
  computed: {},
  data() {
    return {
      setup: {}
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      window.jQuery(this.$refs.form).form("validate form");
      let isValid = window.jQuery(this.$refs.form).form("is valid");
      let vm = this;
      return new Promise((resolve, reject) => {
        if (isValid) {
          local_api(vm, "post", "/student_configuration/do-save-career", {
            u: vm.setup.uuid,
            n: vm.setup.name
          })
            .then(response => {
              vm.$emit("updated", response);
              resolve(response);
            })
            .catch(err => {
              window.jQuery(this.$refs.form).form("add errors", [err]);
              reject(err);
            });
        } else {
          reject();
        }
      });
    }
  },
  created() {
    let vm = this;
    if (vm.career_uuid) {
      local_api(vm, "post", "/student_configuration/do-get-career", {
        u: vm.career_uuid
      })
        .then(career => {
          vm.setup = career;
        })
        .catch(err => {
          vm.$alertify.error(stringify(err));
        });
    }
  },
  mounted() {
    window.jQuery(".ui.menu .item").tab();
    window.jQuery(this.$refs.form).form({
      fields: {
        name: ["empty"]
      }
    });
  },
  watch: {},
  updated: function() {
    let vm = this;
    this.$nextTick(function() {
      window.jQuery(this.$refs.type).dropdown({
        onChange(value) {
          let index = window.jQuery(this).data("index");
          vm.attributes[index].type = value;
        }
      });
    });
  }
};
</script>
